export * from './dlg-transfer.component';
